import React from "react";
import Landing from "./pages/Landing";

function App() {
  return (
    <div>
      <Landing />
    </div>
  );
}

export default App;
